var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWechat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 20
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "wechat_svg__a",
    x1: "50.056%",
    x2: "50.056%",
    y1: "94.15%",
    y2: ".437%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#78D431"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9EEE69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9EEE69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wechat_svg__b",
    x1: "50.089%",
    x2: "50.089%",
    y1: "93.535%",
    y2: "-.036%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E4E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F5F5FF"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#wechat_svg__a)",
    d: "M0 7.212c0 2.164 1.18 4.14 3.003 5.45.16.106.24.266.24.48 0 .054-.026.134-.026.187-.134.534-.375 1.416-.402 1.443-.027.08-.054.133-.054.213 0 .16.134.294.295.294a.382.382 0 00.161-.053L5.12 14.13a.906.906 0 01.456-.133c.08 0 .188 0 .268.027.885.267 1.85.4 2.842.4 4.799 0 8.686-3.232 8.686-7.212C17.372 3.232 13.485 0 8.686 0 3.887 0 0 3.232 0 7.212"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#wechat_svg__b)",
    d: "M16.78 18.669c.828 0 1.63-.108 2.353-.323.053-.027.133-.027.214-.027.133 0 .267.054.374.108l1.578.915c.053.026.08.053.134.053a.24.24 0 00.24-.242c0-.054-.026-.108-.026-.188 0-.027-.214-.754-.321-1.211-.027-.054-.027-.108-.027-.162a.51.51 0 01.214-.403C23.037 16.085 24 14.443 24 12.613c0-3.337-3.236-6.055-7.22-6.055-3.986 0-7.222 2.691-7.222 6.055 0 3.338 3.236 6.056 7.221 6.056z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#187E28",
    d: "M6.907 4.884C6.907 5.507 6.414 6 5.791 6a1.108 1.108 0 01-1.117-1.116c0-.623.494-1.117 1.117-1.117s1.116.494 1.116 1.117m5.791 0c0 .623-.494 1.116-1.117 1.116a1.108 1.108 0 01-1.116-1.116c0-.623.493-1.117 1.116-1.117a1.11 1.11 0 011.117 1.117"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#858C8C",
    d: "M18.28 10.744c0 .543.433.977.976.977a.973.973 0 00.977-.977.973.973 0 00-.977-.977.973.973 0 00-.977.977m-4.814 0c0 .543.434.977.977.977a.973.973 0 00.977-.977.973.973 0 00-.977-.977.973.973 0 00-.977.977"
  }))));
}

export default SvgWechat;